// TODO: Create a snapshot test to validate the ouput of different scenarios
import { useMemo } from 'react';
import { useUserMenuItems } from '../runtime';
const groupBy = (array, property) => array.reduce((grouped, element) => ({
    ...grouped,
    [element[property]]: [...(grouped[element[property]] || []), element],
}), {});
function renderItems(userMenuItems, renderGroup) {
    const groupedByCategory = groupBy(userMenuItems, 'category');
    const keys = Object.keys(groupedByCategory);
    return keys.map((key, keyIndex) => {
        return renderGroup(key, groupedByCategory[key]);
    });
}
export function useRenderedUserMenuItems(renderMenuGroup) {
    const userMenuItems = useUserMenuItems();
    return useMemo(() => {
        return renderItems(userMenuItems, renderMenuGroup);
    }, [userMenuItems, renderMenuGroup]);
}
